import { QueryClientProvider } from "@tanstack/react-query";
import React, { ReactNode } from "react";
import { BrowserRouter } from "react-router-dom";

import { AppErrorBoundary } from "@/components/system/ErrorBoundary";
import { MicroConfirmationProvider } from "@/components/ui2";
import { queryClient } from "@/lib/queryClient";

import { AnalyticsProvider } from "./analytics/AnalyticsContext";
import { AuthProvider } from "./AuthContext";
import { CommandPaletteProvider } from "./CommandPaletteContext";
import { ToastProvider } from "./ToastContext";

// Main app provider that combines all providers
export const AppProviders: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  return (
    <AppErrorBoundary level="app">
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <ToastProvider>
            <MicroConfirmationProvider>
              <CommandPaletteProvider>
                <AuthProvider>
                  <AnalyticsProvider>{children}</AnalyticsProvider>
                </AuthProvider>
              </CommandPaletteProvider>
            </MicroConfirmationProvider>
          </ToastProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </AppErrorBoundary>
  );
};
